import type { SearchOrganisationsQueryResponse } from '~/api/gen'
import { http, HttpResponse } from 'msw'
import { organisations } from '~/msw/mocks/organisation'

// Même critères que le backend : nom, code NS (OID sans préfixe) ou CRPCEN.
export function searchOrganisationsHandler() {
  return http.get<never, never, SearchOrganisationsQueryResponse>('http://localhost:3000/api/v1/organisations', ({ request }) => {
    const search = (new URL(request.url).searchParams.get('search') ?? '').trim().toLowerCase()
    if (!search)
      return HttpResponse.json([])

    const matches = organisations.filter(organisation =>
      organisation.nom.toLowerCase().includes(search)
      || organisation.codeNs.includes(search)
      || organisation.crpcen?.includes(search),
    )
    return HttpResponse.json(matches)
  })
}
